import * as React from "react";
import {Component } from "react";

import "./footer.scss";

import {AppState} from "../app-mobx";
import {MapState} from "../../../core/map-state";
import {UiState} from "../../../core/ui-state";
import {observer} from "mobx-react";
import {ScaleBar} from "../../../core/components/scalebar/scalebar";
import {Attribution} from "../../../core/components/attribution/attribution";
import {Coordinate} from "../../../core/components/coordinate/coordinate";
import {AppConfiguration} from "../../../core/config/app-configuration";


export interface FooterProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    appConfig: AppConfiguration;
}

@observer
export class Footer extends Component<FooterProps, any> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
            search: null
        };
    }

    render(): React.ReactElement | null {
        const topic = this.props.appStore.topic;
        if (!topic) {
            return null;
        }
        return(
            <div className={"geo-app-footer"}>
                <div className={"geo-scalebar-coordinate"}>
                    <ScaleBar config={this.props.appConfig.scaleBar}
                        view={this.props.mapStore.view}
                        uiStore={this.props.uiStore} />
                    <Coordinate view={this.props.mapStore.view}
                        uiStore={this.props.uiStore}/>
                </div>
                <Attribution config={this.props.appConfig.attribution}
                    view={this.props.mapStore.view}
                    uiStore={this.props.uiStore} />
            </div>
        );
    }
}
